import { render, staticRenderFns } from "./SubscriptionModal.vue?vue&type=template&id=55fd4d45&scoped=true&"
import script from "./SubscriptionModal.vue?vue&type=script&lang=js&"
export * from "./SubscriptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fd4d45",
  null
  
)

export default component.exports